import { inicjaly } from "./inicjaly.js";

/**
 * B-8: awatar profilu. Jedna litera z jednowyrazowej nazwy, inicjaly z dwoch i wiecej
 * wyrazow, maksymalnie dwa znaki.
 *
 * TINTUJEMY TLO, NIE LITERE: inicjal zostaje w --text, a tlo dostaje delikatny tint
 * marki (cyan). Odwrotnie - cyan na bieli - byloby nieczytelne.
 *
 * Wyliczanie inicjalow siedzi obok, w components/ui/inicjaly.ts - awatar jest
 * z powloka. Do zgloszenia orkiestratorowi: ten plik powinien przeniesc sie do
 * components/ui/, zeby zaleznosc szla ui -> ui, a nie ui -> shell.
 */
export function Avatar({
  nazwa,
  rozmiar = "m",
}: {
  nazwa: string;
  /** "s" (28px) do wierszy listy, "m" (40px) do naglowka konta. */
  rozmiar?: "s" | "m";
}): React.JSX.Element {
  return (
    <span className={`avatar avatar--${rozmiar}`} aria-hidden="true">
      {inicjaly(nazwa)}
    </span>
  );
}
